/*
 * Copyright © 2017 - 2019 Atilika Inc. All rights reserved.
 */

import axios from "axios";

export enum Mode {
    Normal = 0,
    Search = 1,
    Extended = 2,
    Viterbi = 3
}

export interface Token {
    base: string;
    pos: string;
    pronunciation: string;
    reading: string;
    surface: string;
}

export interface KuromojiResult {
    tokens: [];
    viterbiGraph?: string;
}

export function tokenize(text: string, mode: Mode): Promise<KuromojiResult> {
    return axios
        .post("/kuromoji/rest/tokenizer/tokenize", {
            text: text.slice(0, mode === Mode.Viterbi ? 32 : 512),
            mode
        })
        .then(({data}) => {
            return {
                tokens: data.tokens,
                viterbiGraph: data.viterbi
                    ? data.viterbi.replace('<polygon fill="white"', "")
                    : undefined
            };
        });
}
